import App from './App'

export default App



// WEBPACK FOOTER //
// ./src/components/App/index.js